import styled from "styled-components";
import { theme } from "../../theme/GlobalTheme";

export const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: ${theme.spacing.lg};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  box-sizing: border-box;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: ${theme.spacing.md};
  }
`;

export const Title = styled.h1`
  color: ${theme.colors.primary};
  margin-bottom: ${theme.spacing.lg};
  text-align: center;
  width: 100%;
  font-weight: bold;
  font-size: ${theme.typography.fontSize.h2};
`;

export const Description = styled.p`
  color: ${theme.colors.textPrimary};
  font-size: 18px;
  line-height: 1.6;
  margin-bottom: ${theme.spacing.lg};
  max-width: 800px;
  font-weight: 400;
  text-align: center;
  width: 100%;
`;

export const ProjectGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: ${theme.spacing.md};
  margin-top: 0;
  width: 100%;
  justify-items: center;

  @media (max-width: ${theme.breakpoints.mobile}) {
    grid-template-columns: 1fr;
  }
`;

export const ProjectCard = styled.div`
  width: 100%;
  max-width: 260px;
  height: 320px;
  background: ${theme.colors.primary};
  color: ${theme.colors.white};
  border-radius: ${theme.borderRadius.xlarge};
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
  box-shadow: ${theme.shadows.card};
  display: flex;
  flex-direction: column;

  &:hover {
    transform: translateY(-4px);
    box-shadow: ${theme.shadows.medium};
  }
`;

export const ProjectTitle = styled.div`
  text-transform: uppercase;
  font-size: 18px;
  font-weight: ${theme.typography.fontWeight.bold};
  color: ${theme.colors.white};
  padding: ${theme.spacing.lg};
  background: ${theme.colors.primary};
  text-align: center;
  flex-shrink: 0;
`;

export const ProjectContent = styled.div`
  flex: 1;
  background-size: cover;
  background-position: center;
  padding: ${theme.spacing.lg};
  display: flex;
  align-items: flex-end;
  justify-content: center;
  position: relative;
  
  &.mfe {
    background-image: url('/fusion_abstract_img.jpg');
  }
  
  &.ife {
    background-image: url('/laser_abstract_img.jpg');
  }

  .wh-btn {
    border: none;
    background-color: ${theme.colors.white};
    color: ${theme.colors.primary};
    width: 200px;
    text-align: left;
    padding: 12px 15px;
    font-size: 16px;
    border-radius: ${theme.borderRadius.medium};
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &:hover {
      background-color: ${theme.colors.secondary};
      color: ${theme.colors.white};
    }

    i {
      font-size: 14px;
    }
  }
`;

export const CreateButton = styled.div`
  width: 100%;
  max-width: 260px;
  height: 320px;
  background-color: ${theme.colors.primary};
  color: ${theme.colors.white};
  border-radius: ${theme.borderRadius.xlarge};
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  box-shadow: ${theme.shadows.card};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-weight: ${theme.typography.fontWeight.bold};
  font-size: 18px;

  &:hover {
    background-color: ${theme.colors.secondary};
    transform: translateY(-4px);
    box-shadow: ${theme.shadows.medium};
  }

  span {
    margin-bottom: ${theme.spacing.sm};
  }

  i {
    font-size: 24px;
  }
`;